export enum SmokelessTourStages {
    SKULL,
    CHEW,
    SNUFF,
}
